module.exports = __webpack_public_path__ + "img/random_item.846307b8.png";